import React from 'react'
import { Link } from 'react-router-dom'
function Footer() {
    return (
        <div>

            <footer class="py-3 my-4 bg-success">
                <ul class="nav justify-content-center border-bottom pb-3 mb-3">
                    <li id='blu' class="nav-item"><Link to="/" class="nav-link px-2 ">Home</Link></li>
                    <li id='blu' class="nav-item"><a href="#" class="nav-link px-2 ">Features</a></li>
                    <li id='blu' class="nav-item"><a href="#" class="nav-link px-2 ">Pricing</a></li>
                    <li id='blu' class="nav-item"><a href="#" class="nav-link px-2 ">FAQs</a></li>
                    <li id='blu' class="nav-item"><Link    to='/about'  class="nav-link px-2  active">About</Link></li>
                </ul>
               <Link id='ra' to='https://www.facebook.com/profile.php?id=100004000444519'> <p  class="text-center "> <i>© 2023 Rahul_Chaudhary, Inc</i></p></Link>
            </footer>


        </div>
    )
}

export default Footer
